import * as React from 'react';

export const ColumnThin: ReactFCWithChildren<JSX.IntrinsicElements['svg']> = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <g fill="none" fillRule="evenodd" opacity=".7">
      <g fill="#FFF">
        <g>
          <g>
            <g>
              <path
                d="M16 13.5c.552 0 1 .448 1 1s-.448 1-1 1H4c-.552 0-1-.448-1-1s.448-1 1-1h12zM16 9c.552 0 1 .448 1 1s-.448 1-1 1H4c-.552 0-1-.448-1-1s.448-1 1-1h12zm0-4.5c.552 0 1 .448 1 1s-.448 1-1 1H4c-.552 0-1-.448-1-1s.448-1 1-1h12z"
                transform="translate(-218 -220) translate(128 210) translate(15 10) translate(75)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default ColumnThin;
